import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from "react-redux";

import { DivisionIcon, VCIcon } from '../../../Common/Buttons/TypeIcons';
import { setVehicleDb } from '../../../../Actions/dataActions';
import VehicleCellTooltip from './VehicleCellTooltip';

//Vehicle Cell is 
class VehicleCell extends Component {
    constructor(props) {
        super(props);

        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
        this.showOverlay = this.showOverlay.bind(this);
        this.imageError = this.imageError.bind(this);

        this.state = {
            show_tooltip: false,
            mouseX: 0,
            mouseY: 0,
            tooltip_node: <div />
        };
    }

    componentDidMount() {
        if (this.props.vehicle && ! (this.props.vehicle.V_ID in this.props.data.vehicle_db)) {
            this.props.dispatch(setVehicleDb([this.props.vehicle], this.props.data.vehicle_db))
        }
    }

    showTooltip(event) {
        var event_offsetX = event.clientX;
        var event_offsetY = event.clientY;

        if (window.innerWidth - event_offsetX > 400) {
            event_offsetX = event_offsetX - 5
        } else if(window.innerWidth > 400) {
            event_offsetX = event_offsetX - 400
        } else {
            event_offsetX = event_offsetX - 200
        }

        if (window.innerHeight - event_offsetY > 150) {
            event_offsetY = event_offsetY - 5
        } else {
            event_offsetY = event_offsetY - 150
        }

        this.setState({
            show_tooltip: true,
            mouseX: ($(window).scrollLeft() + event_offsetX),
            mouseY: ($(window).scrollTop() + event_offsetY)
        })
    }

    hideTooltip() {
        this.setState({
            show_tooltip: false
        })
    }

    showOverlay(vehicle) {
        if (!this.props.noOverlay) {
            const { path } = this.props.match;
            const { V_ID, id } = vehicle;

            this.props.history.push(`${path}/vehicle/${V_ID}/Overview/${id}`);
        }
    }

    imageError(e) {
        e.target.src = this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square
    }

    render() {
        if (this.props.vehicle) {
            return (
                <div className="vehicle_cell_container" onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip} onClick={() => this.showOverlay(this.props.vehicle)}>
                    {
                        "displayOnlyName" in this.props && this.props.displayOnlyName ?
                                this.props.vehicle.Year + " " + this.props.vehicle.Make + " " + this.props.vehicle.Model
                            :
                                <div className="vehicle_cell">
                                    { this.props.showImage ?
                                    <div className = "table-vehicle-image">
                                         <div className = "thumbnail" style = {{marginBottom:'0'}}>
                                            {
                                                this.props.vehicle.Photos != '' ?
                                                    <img onError={this.imageError} src={'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_' + this.props.vehicle.Photos} style={{width:'100%'}}/>
                                                :
                                                    <img src={this.props.settings.images.vehicle_placeholder_square.includes("images/") ? this.props.settings.images.vehicle_placeholder_square : "images/" + this.props.settings.images.vehicle_placeholder_square} style={{width:'100%'}}/>
                                            }
                                        </div>
                                    </div> : null} 
                                    <div className = "table-vehicle-name truncate">
                                        {this.props.vehicle.Year} {this.props.vehicle.Make} {this.props.vehicle.Model} {this.props.vehicle.Trim} <br /> <span className = "caption">{this.props.vehicle.VIN}</span>
                                    </div>
                                    {
                                        this.props.showType && window.innerWidth > 800 ? 
                                            <div className="vehicle_cell_type">
                                                {this.props.vehicle.vmh ? VCIcon(this.props.vehicle.vmh, null, null, null, true) : null}
                                                {this.props.vehicle.stakeholder ? DivisionIcon(this.props.vehicle.stakeholder, null, null, null, true) : null}
                                            </div>
                                        :
                                            null
                                    }
                                </div>
                    }

                    {this.state.show_tooltip && (! this.props.noTooltip || this.props.showTooltip) && (
                        ReactDOM.createPortal(<VehicleCellTooltip vehicle={this.props.vehicle} x={this.state.mouseX} y={this.state.mouseY} history={this.props.history} match={this.props.match} location={this.props.location} />, document.getElementById('root'))
                    )}
                </div>
            );
        } else {
            return (
                <div />
            )
        }

    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    data: store.data,
    settings: store.settings
})

export default connect(mapStateToProps)(VehicleCell)